import React__default, { useState, useMemo, useEffect } from 'react';
import _s, { css } from 'styled-components';
import { d as dayjs, D as DatePicker } from './index-f0eabfa6.js';
import Divider from './Divider.js';
import Typography from './Typography.js';
import Icon from './Icon.js';
import Button from './Button.js';
import Box from './Box.js';
import Grid from './Grid.js';
import { D as Drawer } from './Drawer-87194708.js';
import './darken-303c3324.js';
import './_commonjsHelpers-357b3b4e.js';
import './useTheme.js';
import './global-2e5d81b9.js';
import './LoadingIndicator.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';
import './styled-722a6242.js';
import './index-a67b9a05.js';
import './getThemeProps-582952b7.js';
import './useThemeProps-624634df.js';
import './useTheme-3df06c17.js';
import './generateUtilityClasses-06dec860.js';
import './Paper-f4dae82d.js';
import './utils-c09c4ec9.js';
import './useSlotProps-263f7ba4.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import 'react-dom';
import './TransitionGroupContext-42c2fd98.js';
import './useEnhancedEffect-22d6b63a.js';
import './ownerWindow-b54d1bab.js';
import './Portal-4e916b93.js';
import './exactProp-86bc0113.js';
import './debounce-bf764724.js';

var e=function(){var t=1e3,e=6e4,n=36e5,i="millisecond",r="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,m=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,D={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},g=function(t,e,n){var i=String(t);return !i||i.length>=e?t:""+Array(e+1-i.length).join(n)+t},v={s:g,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),i=Math.floor(n/60),r=n%60;return (e<=0?"+":"-")+g(i,2,"0")+":"+g(r,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var i=12*(n.year()-e.year())+(n.month()-e.month()),r=e.clone().add(i,f),s=n-r<0,u=e.clone().add(i+(s?-1:1),f);return +(-(i+(n-r)/(s?r-u:u-r))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:r,ms:i,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},M="en",y={};y[M]=D;var S=function(t){return t instanceof w},p=function(t,e,n){var i;if(!t)return M;if("string"==typeof t)y[t]&&(i=t),e&&(y[t]=e,i=t);else {var r=t.name;y[r]=t,i=r;}return !n&&i&&(M=i),i||!n&&M},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new w(n)},T=v;T.l=p,T.i=S,T.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var w=function(){function D(t){this.$L=p(t.locale,null,!0),this.parse(t);}var g=D.prototype;return g.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(T.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var i=e.match($);if(i){var r=i[2]-1||0,s=(i[7]||"0").substring(0,3);return n?new Date(Date.UTC(i[1],r,i[3]||1,i[4]||0,i[5]||0,i[6]||0,s)):new Date(i[1],r,i[3]||1,i[4]||0,i[5]||0,i[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},g.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},g.$utils=function(){return T},g.isValid=function(){return !(this.$d.toString()===l)},g.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},g.isAfter=function(t,e){return O(t)<this.startOf(e)},g.isBefore=function(t,e){return this.endOf(e)<O(t)},g.$g=function(t,e,n){return T.u(t)?this[e]:this.set(n,t)},g.unix=function(){return Math.floor(this.valueOf()/1e3)},g.valueOf=function(){return this.$d.getTime()},g.startOf=function(t,e){var n=this,i=!!T.u(e)||e,h=T.p(t),l=function(t,e){var r=T.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return i?r:r.endOf(a)},$=function(t,e){return T.w(n.toDate()[t].apply(n.toDate("s"),(i?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},m=this.$W,D=this.$M,g=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return i?l(1,0):l(31,11);case f:return i?l(1,D):l(0,D+1);case o:var M=this.$locale().weekStart||0,y=(m<M?m+7:m)-M;return l(i?g-y:g+(6-y),D);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case r:return $(v+"Milliseconds",3);default:return this.clone()}},g.endOf=function(t){return this.startOf(t,!1)},g.$set=function(t,e){var n,o=T.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[r]=h+"Seconds",n[i]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var m=this.clone().set(d,1);m.$d[l]($),m.init(),this.$d=m.set(d,Math.min(this.$D,m.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},g.set=function(t,e){return this.clone().$set(t,e)},g.get=function(t){return this[T.p(t)]()},g.add=function(i,h){var d,l=this;i=Number(i);var $=T.p(h),m=function(t){var e=O(l);return T.w(e.date(e.date()+Math.round(t*i)),l)};if($===f)return this.set(f,this.$M+i);if($===c)return this.set(c,this.$y+i);if($===a)return m(1);if($===o)return m(7);var D=(d={},d[s]=e,d[u]=n,d[r]=t,d)[$]||1,g=this.$d.getTime()+i*D;return T.w(g,this)},g.subtract=function(t,e){return this.add(-1*t,e)},g.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var i=t||"YYYY-MM-DDTHH:mm:ssZ",r=T.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,r,s){return t&&(t[n]||t(e,i))||r[n].substr(0,s)},c=function(t){return T.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var i=t<12?"AM":"PM";return n?i.toLowerCase():i},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:T.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:T.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:T.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:T.s(u,2,"0"),s:String(this.$s),ss:T.s(this.$s,2,"0"),SSS:T.s(this.$ms,3,"0"),Z:r};return i.replace(m,(function(t,e){return e||$[t]||r.replace(":","")}))},g.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},g.diff=function(i,d,l){var $,m=T.p(d),D=O(i),g=(D.utcOffset()-this.utcOffset())*e,v=this-D,M=T.m(this,D);return M=($={},$[c]=M/12,$[f]=M,$[h]=M/3,$[o]=(v-g)/6048e5,$[a]=(v-g)/864e5,$[u]=v/n,$[s]=v/e,$[r]=v/t,$)[m]||v,l?M:T.a(M)},g.daysInMonth=function(){return this.endOf(f).$D},g.$locale=function(){return y[this.$L]},g.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),i=p(t,e,!0);return i&&(n.$L=i),n},g.clone=function(){return T.w(this.$d,this)},g.toDate=function(){return new Date(this.valueOf())},g.toJSON=function(){return this.isValid()?this.toISOString():null},g.toISOString=function(){return this.$d.toISOString()},g.toString=function(){return this.$d.toUTCString()},D}(),Y=w.prototype;return O.prototype=Y,[["$ms",i],["$s",r],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){Y[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),O.extend=function(t,e){return t.$i||(t(e,w,O),t.$i=!0),O},O.locale=p,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=y[M],O.Ls=y,O.p={},O}();const n=(t,n={minutesRange:30})=>{const i=e(t),r=e(t);return `${i.format("MMM DD, hh:mm")} - ${r.add(n.minutesRange,"minute").format("hh:mm A")}`},i=(t,n={minutesRange:30})=>`${e(t).format("hh:mm")} - ${e(t).add(n.minutesRange,"minute").format("hh:mm A")}`,r=t=>e(t).format("MMM DD, hh:mm A"),s=t=>e(t).format("MMM DD, YYYY"),u=t=>e(t).format("hh:mm A"),a=t=>e(t).format("MMM DD"),o=t=>e(t).format("ddd MMM DD YYYY"),f=()=>({formatDate:s,formatDateTime:r,formatDateTimeWithRange:n,formatTime:u,formatTimeWithRange:i,formatDateShort:a,formatDateLong:o});var h,c,d,$=(h="minute",c=/[+-]\d\d(?::?\d\d)?/g,d=/([+-]|\d\d)/g,function(t,e,n){var i=e.prototype;n.utc=function(t){return new e({date:t,utc:!0,args:arguments})},i.utc=function(t){var e=n(this.toDate(),{locale:this.$L,utc:!0});return t?e.add(this.utcOffset(),h):e},i.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=i.parse;i.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t);};var s=i.init;i.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else s.call(this);};var u=i.utcOffset;i.utcOffset=function(t,e){var n=this.$utils().u;if(n(t))return this.$u?0:n(this.$offset)?u.call(this):this.$offset;if("string"==typeof t&&null===(t=function(t){void 0===t&&(t="");var e=t.match(c);if(!e)return null;var n=(""+e[0]).match(d)||["-",0,0],i=n[0],r=60*+n[1]+ +n[2];return 0===r?0:"+"===i?r:-r}(t)))return this;var i=Math.abs(t)<=16?60*t:t,r=this;if(e)return r.$offset=i,r.$u=0===t,r;if(0!==t){var s=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(r=this.local().add(i+s,h)).$offset=i,r.$x.$localOffset=s;}else r=this.utc();return r};var a=i.format;i.format=function(t){var e=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return a.call(this,e)},i.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},i.isUTC=function(){return !!this.$u},i.toISOString=function(){return this.toDate().toISOString()},i.toString=function(){return this.toDate().toUTCString()};var o=i.toDate;i.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():o.call(this)};var f=i.diff;i.diff=function(t,e,i){if(t&&this.$u===t.$u)return f.call(this,t,e,i);var r=this.local(),s=n(t).local();return f.call(r,s,e,i)};}),D=function(){var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,r){var s,u=function(t,n,i){void 0===i&&(i={});var r=new Date(t);return function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",r=t+"|"+i,s=e[r];return s||(s=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[r]=s),s}(n,i).formatToParts(r)},a=function(e,n){for(var i=u(e,n),s=[],a=0;a<i.length;a+=1){var o=i[a],f=o.type,h=o.value,c=t[f];c>=0&&(s[c]=parseInt(h,10));}var d=s[3],l=24===d?0:d,$=s[0]+"-"+s[1]+"-"+s[2]+" "+l+":"+s[4]+":"+s[5]+":000",m=+e;return (r.utc($).valueOf()-(m-=m%1e3))/6e4},o=i.prototype;o.tz=function(t,e){void 0===t&&(t=s);var n=this.utcOffset(),i=this.toDate(),u=i.toLocaleString("en-US",{timeZone:t}),a=Math.round((i-new Date(u))/1e3/60),o=r(u).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-a,!0);if(e){var f=o.utcOffset();o=o.add(n-f,"minute");}return o.$x.$timezone=t,o},o.offsetName=function(t){var e=this.$x.$timezone||r.tz.guess(),n=u(this.valueOf(),e,{timeZoneName:t}).find((function(t){return "timezonename"===t.type.toLowerCase()}));return n&&n.value};var f=o.startOf;o.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return f.call(this,t,e);var n=r(this.format("YYYY-MM-DD HH:mm:ss:SSS"));return f.call(n,t,e).tz(this.$x.$timezone,!0)},r.tz=function(t,e,n){var i=n&&e,u=n||e||s,o=a(+r(),u);if("string"!=typeof t)return r(t).tz(u);var f=function(t,e,n){var i=t-60*e*1e3,r=a(i,n);if(e===r)return [i,e];var s=a(i-=60*(r-e)*1e3,n);return r===s?[i,r]:[t-60*Math.min(r,s)*1e3,Math.max(r,s)]}(r.utc(t,i).valueOf(),o,u),h=f[0],c=f[1],d=r(h).utcOffset(c);return d.$x.$timezone=u,d},r.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},r.tz.setDefault=function(t){s=t;};}}();e.extend($),e.extend(D);const g=(t,n)=>e(t).tz(n,!0).toDate().getTime(),v=(t,e)=>{const n=t.toLocaleString("en-US",{timeZone:e});return new Date(n)},M=t=>e(t).utc(),y=t=>{const e=t.getTime(),n=t.getTimezoneOffset();return new Date(e+6e4*n)},S=(t,e)=>{if(!t)return e;if(!e)return t;const n=e.getHours(),i=e.getMinutes(),r=y(new Date(t));return r.setHours(n),r.setMinutes(i),r},p=()=>({getDateInTz:v,getDateInServiceAreaTz:g,getUTCDate:M,applyDateTimezone:y,combineDateAndTime:S});

const getPeriodFromAndToDates = ({
  currentDates,
  selectedDate,
  disableEditStartDate
}) => {
  const {
    from,
    to
  } = currentDates;
  if (disableEditStartDate) {
    return {
      from,
      to: selectedDate
    };
  }
  if (!from && !to || from && to) {
    return {
      from: selectedDate,
      to: undefined
    };
  }
  if (from && !to) {
    const beforeFrom = selectedDate < from;
    return beforeFrom ? {
      from: selectedDate,
      to: undefined
    } : {
      from,
      to: selectedDate
    };
  }
  return currentDates;
};

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Calendar = ({
  loading = false,
  submitButtonText,
  datePickerProps,
  endDate,
  endTimePickerOptions,
  multiDateSelection = true,
  onRequestToClose,
  onChangeDates,
  onSubmit,
  visible,
  startDate,
  startTimePickerOptions,
  headerTitleText,
  emptyStartDateText,
  emptyEndDateText,
  emptyTimeslotsText,
  testID,
  headerTestID,
  disableSubmitButton,
  disableEditStartDate,
  disableStartTime,
  disableEndTime,
  helpText,
  disableScrollLock = false
}) => {
  var _a, _b;
  const [dates, setDates] = useState({
    from: startDate,
    to: multiDateSelection ? endDate : undefined
  });
  const hasNoEndOptions = (endTimePickerOptions === null || endTimePickerOptions === void 0 ? void 0 : endTimePickerOptions.length) === 0;
  const hasNoStartOptions = (startTimePickerOptions === null || startTimePickerOptions === void 0 ? void 0 : startTimePickerOptions.length) === 0;
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const {
    getUTCDate,
    combineDateAndTime
  } = p();
  const {
    formatDateLong,
    formatTimeWithRange
  } = f();
  const areTimesInvalid = endTime && startTime && (startTime === null || startTime === void 0 ? void 0 : startTime.getTime()) >= (endTime === null || endTime === void 0 ? void 0 : endTime.getTime());
  const disabled = multiDateSelection ? !dates.to || !dates.from || hasNoEndOptions || hasNoStartOptions || areTimesInvalid : !dates.from || hasNoStartOptions;
  const selectedDays = useMemo(() => {
    if (!dates.from && !dates.to) {
      return undefined;
    }
    if (dates.from && !dates.to) {
      return [dates.from];
    }
    return [dates.from, {
      from: dates.from,
      to: dates.to
    }];
  }, [(_a = dates.from) === null || _a === void 0 ? void 0 : _a.getTime(), (_b = dates.to) === null || _b === void 0 ? void 0 : _b.getTime()]);
  const modifiers = useMemo(() => ({
    start: dates.from,
    end: dates.to
  }), [dates.from, dates.to]);
  const handleDayPress = date => {
    if (date) {
      const range = getPeriodFromAndToDates({
        currentDates: multiDateSelection ? dates : {
          from: date,
          to: undefined
        },
        selectedDate: date,
        disableEditStartDate
      });
      setDates(range);
      if (onChangeDates && range.from && range.to) {
        onChangeDates(combineDateAndTime(range.from, startTime), combineDateAndTime(range.to, endTime));
      }
    }
  };
  const handleStartTimeChange = event => {
    const newDate = dayjs(Number(event.target.value)).toDate();
    setStartTime(newDate);
  };
  const handleEndTimeChange = event => {
    const newDate = dayjs(Number(event.target.value)).toDate();
    setEndTime(newDate);
  };
  const handleSubmit = () => {
    if (dates.from && dates.to) {
      const newStartDate = combineDateAndTime(dates.from, startTime);
      const newEndDate = combineDateAndTime(dates.to, endTime);
      onSubmit(newStartDate, multiDateSelection ? newEndDate : undefined);
      onRequestToClose();
    }
  };
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [visible]);
  useEffect(() => {
    if (startTimePickerOptions === null || startTimePickerOptions === void 0 ? void 0 : startTimePickerOptions.length) {
      const startTimeOption = startTimePickerOptions.find(({
        label
      }) => label === dayjs(startDate).format('hh:mm A') || label === formatTimeWithRange(startDate));
      if (startTimeOption) {
        setStartTime(startTimeOption.value);
      }
    }
  }, [startTimePickerOptions, startDate]);
  useEffect(() => {
    if (endTimePickerOptions === null || endTimePickerOptions === void 0 ? void 0 : endTimePickerOptions.length) {
      const endTimeOption = endTimePickerOptions.find(({
        label
      }) => label === dayjs(endDate).format('hh:mm A'));
      if (endTimeOption) {
        setEndTime(endTimeOption.value);
      }
    }
  }, [endTimePickerOptions, endDate]);
  return /*#__PURE__*/React__default.createElement(Drawer, {
    open: visible,
    anchor: "bottom",
    onClose: onRequestToClose,
    disableScrollLock: disableScrollLock
  }, /*#__PURE__*/React__default.createElement(Box, {
    testID: testID
  }, /*#__PURE__*/React__default.createElement(CalendarContainer, {
    container: true,
    direction: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Box, {
    testID: headerTestID
  }, /*#__PURE__*/React__default.createElement(TitleContainer, null, /*#__PURE__*/React__default.createElement(Box, {
    onPress: onRequestToClose,
    cursor: "pointer"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: "primary",
    name: "24-close-big"
  })), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: "primary",
    variant: "headline-3"
  }, headerTitleText)))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(DateContainer, {
    item: true,
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(DatePicker, {
    variant: multiDateSelection ? 'range' : 'single',
    disabledDays: datePickerProps.disabledDays,
    fromMonth: datePickerProps.fromMonth,
    initialMonth: datePickerProps.initialMonth,
    selectedDays: selectedDays,
    toMonth: datePickerProps.toMonth,
    onSelect: handleDayPress,
    modifiers: modifiers
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: "horizontal-divider"
  }, /*#__PURE__*/React__default.createElement(Divider, null)), /*#__PURE__*/React__default.createElement(TimeContainer, {
    item: true,
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    component: () => /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: "140px",
      textAlign: "center"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: "primary",
      center: true,
      variant: "label-2"
    }, dates.from ? formatDateLong(getUTCDate(dates.from)) : emptyStartDateText)), hasNoStartOptions && startDate ? /*#__PURE__*/React__default.createElement(Box, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption-1",
      color: "success"
    }, emptyTimeslotsText)) : /*#__PURE__*/React__default.createElement(TimeSelect, {
      value: startTime === null || startTime === void 0 ? void 0 : startTime.getTime(),
      onChange: handleStartTimeChange,
      disabled: disableStartTime
    }, startTimePickerOptions.map(({
      value,
      label
    }) => /*#__PURE__*/React__default.createElement("option", {
      key: label,
      value: value.getTime()
    }, label))))
  })), multiDateSelection && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DividerVertical, null), /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    component: () => /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: "140px",
      textAlign: "center"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: "primary",
      center: true,
      variant: "label-2"
    }, dates.to ? formatDateLong(dates.to) : emptyEndDateText)), hasNoEndOptions && endDate ? /*#__PURE__*/React__default.createElement(Box, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption-1",
      color: "success"
    }, emptyTimeslotsText)) : /*#__PURE__*/React__default.createElement(TimeSelect, {
      value: endTime === null || endTime === void 0 ? void 0 : endTime.getTime(),
      onChange: handleEndTimeChange,
      disabled: disableEndTime
    }, endTimePickerOptions.map(({
      value,
      label
    }) => /*#__PURE__*/React__default.createElement("option", {
      key: label,
      value: value.getTime()
    }, label))))
  }))))), helpText && /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: "small",
    marginHorizontal: "medium"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: "quaternary",
    variant: "caption-1",
    center: true
  }, helpText)), /*#__PURE__*/React__default.createElement(Button, {
    loading: loading,
    variant: "primary",
    onPress: handleSubmit,
    disabled: disabled || disableSubmitButton
  }, submitButtonText))));
};
const CalendarContainer = styled(Grid)`
  padding: ${({
  theme
}) => theme.spacings.small}px 0;
  ${({
  theme
}) => css(["background:", ";box-shadow:", ";"], theme.backgroundColors.primary, theme.boxShadows.base)}

  .horizontal-divider {
    width: 100vw;
    padding: ${({
  theme
}) => theme.spacings.small}px 0;
  }

  & button {
    margin: 0 ${({
  theme
}) => theme.spacings.small}px;
  }
`;
const TitleContainer = styled.div`
  position: relative;
  margin-bottom: ${({
  theme
}) => theme.spacings.xxLarge}px;
  & div {
    padding: 0 ${({
  theme
}) => theme.spacings.xSmall}px;
    position: absolute;
    height: 100%;
  }
`;
const DateContainer = styled(Grid)`
  .DayPicker-Caption {
    margin-bottom: ${({
  theme
}) => theme.spacings.small}px;
  }

  .DayPicker-wrapper {
    padding: 0;
  }

  .DayPicker-Month {
    margin: 0;
  }

  .DayPicker-Day {
    font-size: 14px;
  }
`;
const TimeContainer = styled(Grid)`
  margin-bottom: ${({
  theme
}) => theme.spacings.small}px !important;
`;
const TimeSelect = styled.select`
  cursor: pointer;
  border: none;

  ${({
  theme
}) => {
  const font = theme.typographies['caption-1'];
  return css(["background:", ";color:", ";font-family:", ";font-size:", "px;font-weight:", ";line-height:", "px;"], theme.backgroundColors.primary, theme.colors.tertiary, font.fontFamily, font.fontSize, font.fontWeight, font.lineHeight);
}}

  option {
    color: ${({
  theme
}) => theme.colors.primary};
    background: ${({
  theme
}) => theme.backgroundColors.primary};
    &:checked {
      color: ${({
  theme
}) => theme.colors.tertiary};
    }
  }
`;
const DividerVertical = styled.div`
  height: 40px;
  margin: 0 ${({
  theme
}) => theme.spacings.large}px;
  border-left: 2px solid;
  border-color: ${({
  theme
}) => theme.borderColors.primary};
`;

export { Calendar as default };
//# sourceMappingURL=Calendar.js.map
